import React from 'react'

import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Page from '~/components/Page'

const Dashboard = () => {
  const { t } = useTranslation(['home'])
  return (
    <Page title={t('dashboard.title')} freeSolo>
      <Box>This is dashboard</Box>
    </Page>
  )
}

export default Dashboard
